import { ptBR } from "date-fns/locale";

export const MAX_AUTO_LOGINS_ATTEMPTS = 4;

export const APP_IS_RUNNING_IN_DEV = process.env.NODE_ENV === "development";

export const EMPTY_STRING_LABEL = "-";

export const DEFAULT_LOCALE = ptBR;

export const GLOBAL_REFRESH_TIMER = 30 * 60 * 1000;

export const APP_DEFAULT_NUMBER_OF_NOTIFICATIONS = 10;

export const WM_INTERNAL_GROUP_NAME = "White Martins";

export const APP_DEFAULT_API_URL = "https://app-rtu-api.azurewebsites.net/api/";
export const APP_DEFAULT_ENV_STR = "Production - Frontend";

export const APP_DEFAULT_FAVORITE_INSTALLATION_ID = "20042";

export const DEFAULT_RELOAD_MINUTES = 30;

export const TITLE_PAGE = "WM GerenciAR";
